/**
 * SettingsInvitationForm form layout script class
 *
 * @package    Layouts
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, getFormValues } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import DialogActions from '@material-ui/core/DialogActions';

import Button from 'Common/CustomButtons/Button';
import Steppers from 'Common/Steppers';
import {
    SettingsInvitationStepReviewers,
    SettingsInvitationStepEmail,
    SettingsInvitationStepFinal,
} from './SettingsInvitation';

@reduxForm({
    form: 'invitation_send_form',
    enableReinitialize: true,
})
export default class SettingsInvitationForm extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        submitting: PropTypes.bool.isRequired,
        invalid: PropTypes.bool.isRequired,
        initialValues: PropTypes.object,
        journalProps: PropTypes.object.isRequired,
        handleSubmit: PropTypes.func.isRequired,
        handleClose: PropTypes.func.isRequired,
        journalsData: PropTypes.array,
        loading: PropTypes.bool,
    };

    /**
     * State
     *
     * @type {{activeStep: number}}
     */
    state = {
        activeStep: 0,
        invites: [0],
    };

    /**
     * Form counter
     *
     * @type {number}
     */
    counter = 0;

    static contextTypes = {
        store: PropTypes.object,
    };

    /**
     * Steps config
     *
     * @type {*[]}
     */
    steps = () => {
        return [
            {
                label: 'invitations.title.step.reviewers',
                content: <SettingsInvitationStepReviewers
                    journalProps={this.props.journalProps}
                    invites={this.state.invites}
                    addInvite={this.addInvite}
                    buildOnClear={this.buildOnClear}
                />,
            },
            {
                label: 'invitations.title.step.mail',
                content: <SettingsInvitationStepEmail />,
            },
            {
                label: 'invitations.title.step.confirmation',
                content: <SettingsInvitationStepFinal
                    invitations={this.getInvitations()}
                    journalsData={this.props.journalsData}
                />,
            },
        ];
    };

    getInvitations = () => {
        const { store } = this.context;
        const state = store.getState();
        return getFormValues('invitation_send_form')(state);
    };

    /**
     * Add invite button handler
     */
    addInvite = () => {
        const { invites } = this.state;
        this.setState({ invites: [...invites, ++this.counter] });
    };

    /**
     * Build clear invite button handler
     *
     * @param number
     * @returns {function()}
     */
    buildOnClear = number => () => {
        const { invites } = this.state;
        invites.splice(invites.indexOf(number), 1);
        this.setState({ invites: [...invites] });
    };

    /**
     * Next button handler
     */
    handleNext = () => {
        const { activeStep } = this.state;
        this.setState({ activeStep: activeStep + 1 });
    };

    /**
     * Back button handler
     */
    handleBack = () => {
        const { activeStep } = this.state;
        this.setState({ activeStep: activeStep - 1 });
    };

    /**
     * Render
     *
     * @returns {*}
     */
    render() {
        const { handleSubmit, handleClose, submitting, invalid, loading } = this.props;
        const { activeStep } = this.state;

        return (
            <form onSubmit={handleSubmit} id="invitation_send_form">
                <Steppers steps={this.steps()} activeStep={activeStep} />

                <DialogActions>
                    <Button onClick={handleClose} color="danger">
                        <FormattedMessage id="button.cancel" />
                    </Button>
                    {activeStep > 0 && (
                        <Button onClick={this.handleBack} customClass='upload-style-btn'>
                            <FormattedMessage id="button.back" />
                        </Button>
                    )}
                    {activeStep === this.steps().length - 1 ? (
                        <Button onClick={handleSubmit} disabled={submitting || invalid || loading} color="success">
                            <FormattedMessage id="button.invitations.send" />
                        </Button>
                    ) : (
                        <Button onClick={this.handleNext} disabled={invalid} color="primary">
                            <FormattedMessage id="button.next" />
                        </Button>
                    )}
                </DialogActions>
            </form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/Settings/components/SettingsInvitationForm.jsx